import React from 'react';
import background from '../../assets/save-energy.jpg';
import ReusableAskearth from '../../components/ReusableAskearth/ReusableAskearth';


class PromptHomeupgrades extends React.Component {
  render () { 
   return(
  <ReusableAskearth             
    
        tag="TAKE ACTION"
        description01="Can home upgrades help me reduce my utilities?"

        
        background={background}
     />

  );
 }
}   

export default PromptHomeupgrades;
